import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => {
    const topPadding = theme.spacing(3);

    return createStyles({
        root: {
            position: "relative",
        },
        border: {
            left: -3,
            bottom: -7,
            transform: "skewY(1deg)",
            position: "absolute",
            width: "102%",
            height: "100%",
            backgroundColor: theme.palette.common.black,
        },
        texBoxContainer: {
            zIndex: 100,
            position: "relative",
            padding: theme.spacing(3),
            backgroundColor: theme.palette.common.white,
            [theme.breakpoints.down("sm")]: {
                padding: `${topPadding}px ${theme.spacing(2)}px`,
            },
        },
        childContainer: {},
    });
});

export type IWhiteTextBoxClasses = Partial<ReturnType<typeof useStyles>>;

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    classes?: IWhiteTextBoxClasses;
}

export default function WhiteTextBox(props: IProps) {
    const classes = useStyles();
    const { className, classes: overrideClasses, children, ...rest } = props;

    return (
        <div className={clsx(className, classes.root, overrideClasses?.root)} {...rest}>
            <div className={clsx(classes.border, overrideClasses?.border)} />
            <div className={clsx(classes.texBoxContainer, overrideClasses?.texBoxContainer)}>
                <div className={clsx(classes.childContainer, overrideClasses?.childContainer)}>
                    {children}
                </div>
            </div>
        </div>
    );
}
